import {
  IModel,
  IServiceOrder,
  IServiceOrderedServiceLine,
  ServiceCostEstimateApprovalInfo,
  ServiceCostEstimateRejectionInfo,
  ServiceCostEstimateRequestStatus,
  ServiceOrderStatus,
  TransmissionStatus,
} from '@alberta/konexi-shared';

import { AggregateRoot } from '../aggregate-root';

export class ServiceOrderDto extends AggregateRoot implements IServiceOrder, IModel {
  orderedServiceLines: IServiceOrderedServiceLine[];
  startDate: Date;
  endDate: Date;
  therapyId: number;
  therapyTypeId: number;
  woundLocation: number;
  patientId: string;
  doctorId: string;
  payerInstitutionCode: string;
  isInitialCare: boolean;
  annotation: string;
  integratedCareId: string;
  status: ServiceOrderStatus;
  medicalOrderRequestStatus: TransmissionStatus;
  regionId: string;
  createdAt: Date;
  createdBy: string;
  updatedAt: Date;
  updatedBy: string;
  transmittedAt: string;
  additionalLocations?: string[];
  serviceCostEstimateRequestStatus: ServiceCostEstimateRequestStatus;
  serviceCostEstimateCreationInfo: { createdAt: string; createdBy: string };
  serviceCostEstimateApprovalOrRejection: ServiceCostEstimateRejectionInfo | ServiceCostEstimateApprovalInfo;
  hasFollowUpOrder: boolean;
  medicalOrderDate: string;

  constructor() {
    super();
  }
}
